import { render } from "./Advantage.vue?vue&type=template&id=495cb224"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__